import { Country } from '../country/country';

export enum Currency {
  Australia = 'AUD',
  Canada = 'CAD',
  Malaysia = 'MYR',
  NewZealand = 'NZD',
  Qatar = 'QAR',
  SaudiArabia = 'SAR',
  Singapore = 'SGD',
  UnitedArabEmirates = 'AED',
  UnitedKingdom = 'GBP',
  UnitedStates = 'USD',
  Europe = 'EUR',
  Poland = 'PLN',
  // Turkey = 'TRY',
  Kazakhstan = 'KZT',
  Mongolia = 'MNT',
  // Uzbekistan = 'UZS',
  Azerbaijan = 'AZN',
  Switzerland = 'CHF',
  Denmark = 'DKK',
  Norway = 'NOK',
  Japan = 'JPY',
}

export const CountryCurrency: Record<Country, Currency> = {
  [Country.Australia]: Currency.Australia,
  [Country.Canada]: Currency.Canada,
  [Country.Malaysia]: Currency.Malaysia,
  [Country.NewZealand]: Currency.NewZealand,
  [Country.Qatar]: Currency.Qatar,
  [Country.SaudiArabia]: Currency.SaudiArabia,
  [Country.Singapore]: Currency.Singapore,
  [Country.UnitedArabEmirates]: Currency.UnitedArabEmirates,
  [Country.UnitedKingdom]: Currency.UnitedKingdom,
  [Country.UnitedStates]: Currency.UnitedStates,
  [Country.Netherlands]: Currency.Europe,
  [Country.Belgium]: Currency.Europe,
  [Country.Germany]: Currency.Europe,
  [Country.France]: Currency.Europe,
  //[Country.Spain]: Currency.Europe,
  [Country.Poland]: Currency.Poland,
  // [Country.Turkey]: Currency.Turkey,
  [Country.Kazakhstan]: Currency.Kazakhstan,
  [Country.Mongolia]: Currency.Mongolia,
  // [Country.Uzbekistan]: Currency.Uzbekistan,
  [Country.Azerbaijan]: Currency.Azerbaijan,
  [Country.Switzerland]: Currency.Switzerland,
  [Country.Denmark]: Currency.Denmark,
  [Country.Norway]: Currency.Norway,
  [Country.Japan]: Currency.Japan,
} as const;

export const CountryLocale: Record<Country, string> = {
  [Country.Australia]: 'au',
  [Country.Canada]: 'ca',
  [Country.Malaysia]: 'my',
  [Country.NewZealand]: 'nz',
  [Country.Qatar]: 'qa',
  [Country.SaudiArabia]: 'sa',
  [Country.Singapore]: 'sg',
  [Country.UnitedArabEmirates]: 'ae',
  [Country.UnitedKingdom]: 'gb',
  [Country.UnitedStates]: 'us',
  [Country.Netherlands]: 'nl',
  [Country.Belgium]: 'be',
  [Country.Germany]: 'de',
  [Country.France]: 'fr',
  //[Country.Spain]: 'es',
  [Country.Poland]: 'pl',
  // [Country.Turkey]: 'tr',
  [Country.Kazakhstan]: 'kz',
  [Country.Mongolia]: 'mn',
  // [Country.Uzbekistan]: 'uz',
  [Country.Azerbaijan]: 'az',
  [Country.Switzerland]: 'ch',
  [Country.Denmark]: 'dk',
  [Country.Norway]: 'no',
  [Country.Japan]: 'jp',
} as const;

export const CurrencyIcons: Record<Country, string> = {
  [Country.Australia]: 'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/AUD.jpg',
  [Country.Canada]: 'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/CAD.svg',
  [Country.Malaysia]: 'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/MYR.jpg',
  [Country.NewZealand]: 'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/NZD.svg',
  [Country.Qatar]: 'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/QAR.svg',
  [Country.SaudiArabia]: 'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/SAR.svg',
  [Country.Singapore]: 'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/SGD.jpg',
  [Country.UnitedArabEmirates]:
    'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/AED.svg',
  [Country.UnitedKingdom]: 'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/GBP.svg',
  [Country.UnitedStates]: 'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/USD.jpg',
  [Country.Poland]: 'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/PL.svg',
  [Country.Netherlands]: 'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/NL.svg',
  [Country.Belgium]: 'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/BE.svg',
  [Country.Germany]: 'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/DE.svg',
  [Country.France]: 'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/FR.svg',
  //[Country.Spain]: 'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/ES.svg',
  // [Country.Turkey]: 'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/TRY.webp',
  [Country.Kazakhstan]: 'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/KZT.webp',
  [Country.Mongolia]: 'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/MNT.webp',
  // [Country.Uzbekistan]: 'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/UZS.webp',
  [Country.Azerbaijan]: 'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/AZN.webp',
  [Country.Switzerland]: 'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/CHF.webp',
  [Country.Denmark]: 'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/DKK.webp',
  [Country.Norway]: 'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/NOK.webp',
  [Country.Japan]: 'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/JPY.webp',
};
export const NON_DECIMAL_CURRENCIES = [Currency.Japan];

export const CURRENCY_DECIMALS: Record<Currency, number> = {
  [Currency.Australia]: 2,
  [Currency.Canada]: 2,
  [Currency.Malaysia]: 2,
  [Currency.NewZealand]: 2,
  [Currency.Qatar]: 2,
  [Currency.SaudiArabia]: 2,
  [Currency.Singapore]: 2,
  [Currency.UnitedArabEmirates]: 2,
  [Currency.UnitedKingdom]: 2,
  [Currency.UnitedStates]: 2,
  [Currency.Europe]: 2,
  [Currency.Poland]: 2,
  // [Currency.Turkey]: 2,
  [Currency.Kazakhstan]: 2,
  [Currency.Mongolia]: 2,
  // [Currency.Uzbekistan]: 2,
  [Currency.Azerbaijan]: 2,
  [Currency.Switzerland]: 2,
  [Currency.Denmark]: 2,
  [Currency.Norway]: 2,
  [Currency.Japan]: 0,
};

export const CURRENCY_INFO: Record<Currency, { symbol: string; position: 'prefix' | 'suffix' }> = {
  [Currency.Australia]: { symbol: 'A$', position: 'prefix' },
  [Currency.Canada]: { symbol: 'CA$', position: 'prefix' },
  [Currency.Malaysia]: { symbol: 'RM', position: 'prefix' },
  [Currency.NewZealand]: { symbol: 'NZ$', position: 'prefix' },
  [Currency.Qatar]: { symbol: 'ر.ق', position: 'suffix' },
  [Currency.SaudiArabia]: { symbol: 'ر.س', position: 'suffix' },
  [Currency.Singapore]: { symbol: 'S$', position: 'prefix' },
  [Currency.UnitedArabEmirates]: { symbol: 'د.إ', position: 'suffix' },
  [Currency.UnitedKingdom]: { symbol: '£', position: 'prefix' },
  [Currency.UnitedStates]: { symbol: '$', position: 'prefix' },
  [Currency.Europe]: { symbol: '€', position: 'prefix' },
  [Currency.Poland]: { symbol: 'zł', position: 'prefix' },
  // [Currency.Turkey]: { symbol: '₺', position: 'prefix' },
  [Currency.Kazakhstan]: { symbol: '₸', position: 'prefix' },
  [Currency.Mongolia]: { symbol: '₮', position: 'prefix' },
  // [Currency.Uzbekistan]: { symbol: 'UZS', position: 'prefix' },
  [Currency.Azerbaijan]: { symbol: '₼', position: 'prefix' },
  [Currency.Switzerland]: { symbol: 'CHF', position: 'prefix' },
  [Currency.Denmark]: { symbol: 'kr.', position: 'prefix' },
  [Currency.Norway]: { symbol: 'kr', position: 'prefix' },
  [Currency.Japan]: { symbol: '¥', position: 'prefix' },
};
